import { useState } from 'react';
import { 
  Box,
  Typography,
  Stack,
  MenuItem,
  Link,
  Popover,
  Button,
  useTheme
} from '@mui/material';
import { FILES_URL } from 'src/Api';
import { ChevronDown } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../actions/auth';
import RouterLink from 'src/hooks/RouterLink';
import { AccountBox, Logout } from '@mui/icons-material';

export default function AccountPopover() {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          borderRadius: '9999px',
          border: `1px solid ${isDark ? '#555' : '#e0e0e0'}`,
          boxShadow: 'sm',
          px: 2,
          py: 1,
          backgroundColor: isDark ? '#1e1e1e' : 'white',
          '&:hover': {
            backgroundColor: isDark ? '#2c2c2c' : 'white',
          }
        }}
      >
        {
          auth.user.role === 1 &&
        <Box 
          component="img" 
          src={FILES_URL + auth.user.avatar} 
          alt="Profile" 
          sx={{ 
            width: 24, 
            height: 24, 
            borderRadius: '50%',
          }}
        />
}
        <Typography 
          sx={{ 
            color: isDark ? '#eee' : '#666',
            fontWeight: 500,
            mx: '15px'
          }}
        >
          { auth.user.fname + ' ' + auth.user.name }
        </Typography>
        <ChevronDown size={16} color={isDark ? '#eee' : '#666'} />
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            width: 200,
            borderRadius: 1,
            backgroundColor: isDark ? '#2c2c2c' : 'white',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            color: isDark ? '#eee' : 'inherit',
          }
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {auth.user.name + ' ' + auth.user.fname}
          </Typography>
          <Typography variant="body2" sx={{ color: isDark ? '#aaa' : 'text.secondary' }} noWrap>
            {auth.user.email}
          </Typography>
        </Box>

        {auth.user.role === 1 && (
          <MenuItem onClick={handleClose} sx={{ borderRadius: 1 }}>
            <Link
              color="text.primary"
              component={RouterLink}
              underline="none"
              href="/dashboard/profile_pro"
            >
              <Stack spacing={1} direction="row" alignItems="center">
                <AccountBox fontSize="small" /> 
                <Typography>Profil</Typography>
              </Stack>
            </Link>
          </MenuItem>
        )}

        {auth.user.role === 2 && (
          <MenuItem onClick={handleClose} sx={{ borderRadius: 1 }}>
            <Link
              color="text.primary"
              component={RouterLink}
              underline="none"
              href="/dashboard/account"
            >
              <Stack spacing={1} direction="row" alignItems="center">
                <AccountBox fontSize="small" /> 
                <Typography>Mon compte</Typography>
              </Stack>
            </Link>
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            dispatch(logout());
            handleClose();
          }}
          sx={{ borderRadius: 1 }}
        >
          <Stack spacing={1} direction="row" alignItems="center">
            <Logout fontSize="small" /> 
            <Typography>Se déconnecter</Typography>
          </Stack>
        </MenuItem>
      </Popover>
    </>
  );
}